import {BusinessUnitVetAlertModel} from "../../../models/customers/customer.models";
import * as Enumerable from "linq";

export class VettingActionFilterValueConverter {
    toView(items: BusinessUnitVetAlertModel[], filterIds: number[]) {
        if (!filterIds || filterIds.length === 0) return items;

        const enumerable = Enumerable.from(filterIds);
        const itemsEnumerable = Enumerable.from(items);
        return itemsEnumerable.where(x => enumerable.contains(x.vettingActionId)).toArray();
    }
}